export default __webpack_public_path__ + "static/media/saunatimeFacebook-1200x630.2eb29b0f.jpg";